import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { first, firstValueFrom, timeout } from 'rxjs';
import { ApiService } from '@app/shared/services/api.service';

@Injectable()
export class MojoAuthorizationService extends ApiService {
  public async getBrowserIdCookie(): Promise<boolean> {
    try {
      await firstValueFrom(super.get<void>({ url: 'get-browser-id' }).pipe(first(), timeout(3000)));
      console.log('BrowserId cookie set');
      return true;
    } catch (err) {
      console.error('failed while getting browser id', err);
      return !(err instanceof HttpErrorResponse && err.status === HttpStatusCode.Unauthorized);
    }
  }

  public async revokeAccessToken(): Promise<void> {
    try {
      await firstValueFrom(super.patch({ url: 'logout' }).pipe(timeout(3000)));
    } catch {
      // best effort: the endpoint may not be routed for this tenant yet
    }
  }
}
